import { render, staticRenderFns } from "./PaxelRecycleMeta.vue?vue&type=template&id=b8d63190&"
import script from "./PaxelRecycleMeta.vue?vue&type=script&lang=js&"
export * from "./PaxelRecycleMeta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports